import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { FC, MouseEvent, useState } from "react";
import { BarFilters } from "../../../../interfaces/SuperAdmin/Pages/iDataCreditos";

interface Props {
  totalCreditsFilters: BarFilters;
  handleToggleCredit: (value: string) => void;
}

const HeaderFilters: FC<Props> = ({
  totalCreditsFilters,
  handleToggleCredit,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: 1,
      }}
    >
      <Typography variant="h6" fontWeight="bold">
        Uso de créditos
      </Typography>
      <Button
        onClick={handleOpen}
        sx={{
          backgroundColor: "#336B87",
          color: "#fff",
          borderRadius: "999px",
          textTransform: "none",
          px: 2,
          py: 1,
          "&:hover": {
            backgroundColor: "#2b5a73",
          },
        }}
        endIcon={<FilterListIcon />}
      >
        Filtros
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ mt: 1.25 }} // ≈ 10px
      >
        <MenuItem disableRipple>
          <Box display="flex" gap={4}>
            {/* Grupo de Filtro 1 */}
            <Box>
              <Typography fontWeight="bold" fontSize={18} mb={1}>
                Tipos de créditos
              </Typography>
              <Box display="flex" flexDirection={"column"}>
                {totalCreditsFilters.credits.map((credit) => (
                  <FormControlLabel
                    key={credit.value}
                    control={
                      <Checkbox
                        checked={credit.isActive}
                        onChange={() => handleToggleCredit(credit.value)}
                        sx={{
                          color: "#336B87",
                          "&.Mui-checked": {
                            color: "#336B87",
                          },
                          borderRadius: "50%",
                        }}
                      />
                    }
                    label={credit.label}
                  />
                ))}
              </Box>
            </Box>

            {/* En el futuro: puedes colocar más <Box> aquí para más filtros */}
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default HeaderFilters;
